export default __webpack_public_path__ + "static/media/calender.39727667.svg";